export default "__VITE_ASSET__BTdWsI2o__"